<template>
  <div class="progress">
    <span class="progress__info u-tar u-dimmed">
      {{ timeFormated(currentTime) }}
    </span>

    <label class="progress__slider">
      <span class="u-sr-only">{{ $t('progress_control') }}</span>
      <vue-slider ref="vueSlider" :value="progressPourcent"
                  v-bind="sliderProps" :processStyle="{ backgroundColor: `rgb(${this.themeColor.join(',')})` }"
                  v-on:drag-start="dragStart"
                  v-on:drag-end="dragEnd"
                  v-on:callback="updateProgress"></vue-slider>
    </label>

    <span class="progress__info u-dimmed">
      {{ timeFormated(duration) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    currentTime: {
      type: Number,
      default: 0.0
    },
    initialTime: {
      type: Number,
      default: 0.0
    },
    duration: {
      type: Number,
      default: 0.0
    },
    themeColor: {
      type: Array,
      default: [0, 0, 0]
    },
    isMenuOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      sliderInUse: false,
      sliderProps: {
        tooltip: false,
        bgStyle: { backgroundColor: 'rgba(255,255,255, 0.25)' },
        height: 3,
        dotSize: 25
      }
    }
  },

  mounted () {
    if (this.initalTime !== 0) {
      this.$emit('timeupdate', this.initialTime)
    }
  },

  watch: {
    isMenuOpen () {
      this.$refs.vueSlider.refresh()
    }
  },

  computed: {
    progressPourcent () {
      // Sometime when changing track currentTime value is higher
      // than the duration of the track and VueSlider return an error
      // ex.: [VueSlider error]: The value of the slider is 175.45794392523365, the maximum value is 100,
      //      the value of this slider can not be greater than the maximum value
      if (this.currentTime >= this.duration) return 100

      return this.currentTime / this.duration * 100
    }
  },

  methods: {
    dragStart (context) {
      this.sliderInUse = true
    },

    dragEnd (context) {
      this.sliderInUse = false
      this.updateProgress(context.getValue())
    },

    updateProgress (slideValue) {
      if (this.sliderInUse) return

      this.$emit('timeupdate', slideValue * this.duration / 100)
    },

    timeFormated (floatSeconds) {
      let seconds = Math.round(floatSeconds)
      let m = Math.floor(seconds / 60)
      let s = seconds % 60
      let twoDigitFormat = function (int) {
        let prefix = int < 10 ? '0' : ''
        return `${prefix}${int}`
      }

      return `${twoDigitFormat(m)}:${twoDigitFormat(s)}`
    }
  }
}
</script>

<style>
  .progress {
    display: flex;
    align-items: center;
  }

  .progress__slider {
    flex-grow: 1;
  }

  .progress__info {
    width: 3em;
    font-size: 0.87em;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue